module.exports = __webpack_public_path__ + "img/home--how--schedule.155687c1.svg";